<template>
    <div id="welcome">
        <popup ref="popup" type="center" @close="popClose">
            <div class="welcome_panel">
                <div class="panel_main">
                    <img src="./img/ads/img_icon_10.png" class="close_btn" @click="popClose" />
                    <div class="panel_title">您好，欢迎访问
                      <img class="logo_img" src="./img/header/logo2.jpg">Runway中文站</div>

                    <div class="panel_subtitle">Ai视频首选Runway视频，行业公认出视频质量最高的Ai视频软件</div>
                    <div class="panel_content">
                        <div class="panel_item play_video">
                            <div class="item_top">已经有 168641231 人看过新手视频</div>
                            <div class="item_content" @click="showVideDialog">
                                <img class="video_icon" src="./img/ads/img_icon_16.png" alt="">
                                <div class="content_text"><span class="text_span">新用户福利视频教程<img class="hot_icon" src="./img/ads/img_icon_02.gif" alt=""></span></div>
                                <div class="content_tips">如何快速让Ai制作自己满意的视频？</div>
                            </div>
                        </div>
                        <div class="panel_item">
                            <div class="item_top"></div>
                            <div class="item_content">
                                <div @click="popClose" class="skip">不想看，点此跳过<i class="el-icon-d-arrow-right"></i></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel_aside">
                    <div class="aside_main">
                        <div class="aside_main_content">
                            <div class="content_text">本站累计Ai视频数量</div>
                            <div class="content_text large"><span class="docnum">{{ total_num }}</span> 个</div>
                            <div class="content_text red">{{ currentMonth }}月{{ currentDate }}日Ai视频数量</div>
                            <div class="content_text large"><span class="docnum">{{ docnum }}</span> 个</div>
                        </div>
                        <div class="aside_main_bottom">
                            <div class="bottom_text">新用户登录成功即送<br/>会员优惠券</div>
                        </div>
                    </div>
                    <div class="aside_video">
                        <img class="hot_icon" src="./img/ads/img_icon_19.png" alt="">
                        <img @click="showVideDialog" class="video_icon" src="./img/ads/img_icon_16.png" alt="">
                        <div class="video_text">新用户福利视频教程</div>
                        <div class="video_tips">如何快速让Ai制作自己满意的视频？</div>
                    </div>
                </div>
            </div>
        </popup>
        <videoDialog ref="videoDialog"></videoDialog>
    </div>
</template>
<script type="text/ecmascript-6">
    import popup from "COMPONENTS/Popup.vue"
    import videoDialog from "COMPONENTS/VideoDialogAd.vue"
    export default {
        components:{popup, videoDialog},
        data() {
            return {
                todayText:"",
                today_doc_num:0,
                site_name:SITE_NAME,
              currentMonth: '', // 当前月份
              currentDate: '',  // 当前日期
              docnum:0,
              total_num:0,
            }
        },
        created() {
            let date = new Date();
            let month = date.getMonth()+1;
            let day = date.getDate();
            this.todayText = month + "月" + day + "日";
          const now = new Date();
          this.currentMonth = now.getMonth() + 1; // getMonth() 返回的月份是从 0 开始的，所以需要加 1
          this.currentDate = now.getDate();
            // this.$http.get(`/front/document/index/`,{params:{page:this.page}}).then(res =>{
            //         if(res.status=='200'){
            //             this.docnum = res.data.total_num
            //             this.today_doc_num = res.data.today_doc_num

            //         }
            //     })
          this.totalDongHua()
        },
        methods: {
            show(){
                this.$refs.popup.show();
            },
            popClose(){
                this.$refs.popup.close();
                if (JUMP_DIALOG == 1) { // 直接跳主页
                    let tgad = this.getCache("tgad") || ""
                    let adsid = this.getCache("site_id") || ""
                    let msclkid = this.getCache("msclkid") || ""
                    let bd_vid = this.getCache("bd_vid") || ""
                    let qhclickid = this.getCache("qhclickid") || ""
                    let sourceid = this.getCache("sourceid") || ""
                    let adaid = this.getCache("ad_account_id") || "" 
                    let url = MAIN_URLROOT + "?adaid=" + adaid + "&tgad=" + tgad + "&adsid=" + adsid
                    if(msclkid){
                        url += "&msclkid=" + msclkid
                    }
                    if(bd_vid){
                        url += "&bd_vid=" + bd_vid
                    }
                    if(qhclickid){
                        url += "&qhclickid=" + qhclickid
                    }
                    if(sourceid){
                        url += "&sourceid=" + sourceid
                    }
                    location.href = url
                } else {
                   this.$router.replace({path: '/video'})
                }
            },
            showVideDialog(){
                this.$refs.popup.close();
                this.$refs.videoDialog.show()
            },
          totalDongHua(){
            this.$http.get(`/front/aivideo/draw/num/`).then((res) => {
              this.total_num = res.data.total_num;
              let today_doc_num = res.data.today_doc_num;

              let step = parseInt(today_doc_num/20);
              let timer = setInterval(()=>{
                this.docnum = this.docnum + step;
                if(this.docnum > today_doc_num){
                  this.docnum = today_doc_num;
                  clearInterval(timer);
                }
              },100)
            })
          },
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .welcome_panel{
        display: flex;
        font-size: 14px;
        .panel_main{
            width: 860px;
            height: 560px;
            position: relative;
            padding: 26px 70px;
            text-align: center;
            background-color: #fff;
            border-radius: 3px;
            margin-right: 14px;
            .panel_title{
              color: black;
                font-size: 28px;
                line-height: 70px;
                .logo_img{
                  width: 30px;
                  height: 30px;
                  border-radius: 4px;
                  margin: 0 5px 2px 0;
                    //width: 38px;
                    //margin: -3px 0 0 8px;
                    vertical-align: middle;
                }
            }
            .panel_subtitle{
                font-size: 14px;
                line-height: 57px;
                color: #999;
                // font-weight: bold;
            }
            .panel_content{
                padding-top: 38px;
                display: flex;
                .panel_item{
                    flex-grow: 1;
                    width: 0;
                    &.play_video{
                        margin-right: 12px;
                        .item_top{
                            border: 1px solid #ccc;
                            background-color: #f5f5f5;
                            line-height: 50px;
                            position: relative;
                            color: #999;
                            border-radius: 3px;
                            &::after{
                                content: "";
                                position: absolute;
                                display: block;
                                width: 14px;
                                height: 14px;
                                border: 1px solid #ccc;
                                border-top-color: transparent;
                                border-left-color: transparent;
                                left: 50%;
                                bottom: -7px;
                                box-sizing: border-box;
                                transform-origin: center;
                                transform: rotate(45deg);
                                background-color: #f5f5f5;
                            }
                        }
                        .item_content{
                            background-color: #f5f5f5;
                            padding-top: 50px;
                            .video_icon{
                                width: 36px;
                                display: block;
                                margin: 0 auto;
                                cursor: pointer;
                            }
                            .content_text{
                                line-height: 62px;
                                .text_span{
                                    position: relative;
                                    .hot_icon{
                                        position: absolute;
                                        top: -15px;
                                        right: -23px;
                                    }
                                }
                            }
                            .content_tips{
                                color: #999;
                                line-height: 46px;
                            }
                        }
                    }
                    .item_top{
                        height: 52px;
                        margin-bottom: 11px;
                    }
                    .item_content{
                        height: 240px;
                        border-radius: 3px;
                        border: 1px solid #ccc;
                        position: relative;
                        .skip{
                            color: #cccccc;
                            font-size: 14px;
                            cursor: pointer;
                            position: absolute;
                            top: 50%;
                            line-height: 28px;
                            margin-top: -14px;
                            width: 100%;
                        }
                    }
                }
            }
            .close_btn{
                position: absolute;
                top: 12px;
                right: 12px;
                width: 14px;
                height: 14px;
                cursor: pointer;
            }
        }
        .panel_aside{
            width: 255px;
            display: flex;
            flex-direction: column;
            .aside_main{
                flex-grow: 1;
                margin-bottom: 14px;
                background-color: #fff;
                background-image: url("./img/ads/img_icon_32.png");
                background-repeat: no-repeat;
                background-position: right 10px;
                display: flex;
                flex-direction: column;
                border-radius: 3px;
                .aside_main_content{
                    padding-top: 2px;
                    text-align: center;
                    flex-grow: 1;
                    line-height: 32px;
                    .content_text{
                        margin-top: 26px;
                        &.large{
                            margin-top: 34px;
                        }
                        .docnum{
                            font-size: 28px;
                        }
                    }
                }
                .aside_main_bottom{
                    height: 65px;
                    padding-top: 10px;
                    background-size: 100% 100%;
                    background-image: url("./img/ads/img_icon_18.png");
                    display: flex;
                    align-items: center;
                    color: #999;
                    line-height: 22px;
                    padding-left: 18px;
                }
            }
            .aside_video{
                height: 182px;
                flex-shrink: 0;
                border-radius: 3px;
                background-color: #fff;
                text-align: center;
                padding-top: 38px;
                position: relative;
                .hot_icon{
                    position: absolute;
                    top: 0;
                    right: 0;
                    border: none;
                }
                .video_icon{
                    width: 38px;
                    display: block;
                    margin: 0 auto;
                    cursor: pointer;
                }
                .video_text{
                    line-height: 60px;
                }
                .video_tips{
                    color: #999;
                    line-height: 40px;
                }
            }
        }
    }
</style>